module.exports = __webpack_public_path__ + "img/Misi Working Style-Icon Conventional0.f8b36f26.png";